import namespace from "@rdfjs/namespace";
const builder = namespace("https://www.ica.org/standards/RiC/ontology#");
export const strict = builder;
export const loose = builder;
